import { TabNav } from '@customerio/pluma-components/react';
import { useLocation } from 'react-router-dom';
import { getWorkspaceIdFromCurrentUrl } from '@/context/current-workspace';
import { generatePath } from '@/services/router/generate-path';

export function AnalysisTabs() {
  const location = useLocation();
  const workspaceId = getWorkspaceIdFromCurrentUrl() ?? 0;

  const journeysAnalysisPath = generatePath('/workspaces/:workspaceId/journeys/analysis', { workspaceId });
  const deliverabilityPath = generatePath('/workspaces/:workspaceId/analysis/deliverability', { workspaceId });

  const tabs = [
    {
      href: journeysAnalysisPath,
      text: 'Performance',
      isActive:
        location.pathname === journeysAnalysisPath || location.pathname.startsWith(`${journeysAnalysisPath}/index`),
    },
    {
      href: deliverabilityPath,
      text: 'Deliverability',
      isActive: location.pathname.includes('/analysis/deliverability'),
    },
  ];

  return <TabNav tabs={tabs} />;
}
